import { DefaultAvatar } from "../ProfileSummary/index.jsx";
import React from "react";
import { fmtNum } from "../../shared/utils";
import { sourceImage } from "../../utils/source-image";
import { isScreenAllowed } from "../../shared/accessControl";
const data = {
  feed: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  ),
  ranking: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="18" y1="20" x2="18" y2="10" />
      <line x1="12" y1="20" x2="12" y2="4" />
      <line x1="6" y1="20" x2="6" y2="14" />
    </svg>
  ),
  estudo: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),
  loja: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
      <line x1="3" y1="6" x2="21" y2="6" />
      <path d="M16 10a4 4 0 0 1-8 0" />
    </svg>
  ),
  conteudo: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </svg>
  ),
  vestibular: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M22 10L12 5 2 10l10 5 10-5z" />
      <path d="M6 12v5c0 1.66 2.69 3 6 3s6-1.34 6-3v-5" />
    </svg>
  ),
  simulador: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  ),
  desafio: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
    </svg>
  ),
  olimpiada: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M8 21h8" />
      <path d="M12 17v4" />
      <path d="M7 4h10v5a5 5 0 0 1-10 0z" />
      <path d="M7 5H4a1 1 0 0 0-1 1v1a4 4 0 0 0 4 4" />
      <path d="M17 5h3a1 1 0 0 1 1 1v1a4 4 0 0 1-4 4" />
    </svg>
  ),
  merito: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="8" r="6" />
      <path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11" />
    </svg>
  ),
  enviar: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="22" y1="2" x2="11" y2="13" />
      <polygon points="22 2 15 22 11 13 2 9 22 2" />
    </svg>
  ),
  perfil: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  admin: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  sair: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
  ),
  menu: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
    >
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  ),
};
export function Sidebar(props) {
  let view = props.view;
  let goto = props.goto;
  let currentStudent = props.currentStudent;
  let adminLogged = props.adminLogged;
  let houses = props.houses;
  let logout = (props.setStudentId, props.setAdminLogged, props.logout);
  let showFlash = props.showFlash;
  let getTokensDisponiveis = props.getTokensDisponiveis;
  let getPontosRank = props.getPontosRank;
  let questPend = props.questPend;
  let desPend = (props.resgPend, props.desPend);
  let agPendHoje = props.agPendHoje;
  let open = props.open;
  let onClose = props.onClose;
  let adminAba = props.adminAba;
  let setAdminAba = props.setAdminAba;
  let notificationDots = props.menuDots || {};
  const casa = currentStudent
    ? houses.find((house) => house.id === currentStudent.casa_id)
    : null;
  const tok = currentStudent
    ? Math.max(0, getTokensDisponiveis(currentStudent.id))
    : 0;
  const pts = currentStudent ? getPontosRank(currentStudent.id) : 0;
  const nav = (value) => {
    goto(value);
    onClose();
  };
  const itensAluno = [
    {
      v: "conteudos",
      label: "Reforço",
      icon: data.conteudo,
    },
    {
      v: "vestibulares",
      label: "Vestibulares",
      icon: data.vestibular,
    },
    {
      v: "simuladores-conteudo",
      label: "Simuladores",
      icon: data.simulador,
    },
    {
      v: "olimpiada-conteudo",
      label: "Olimpíadas",
      icon: data.olimpiada,
    },
    {
      v: "tarefas",
      label: "Tarefas",
    },
    {
      v: "rankings",
      label: "Ranking",
      icon: data.ranking,
    },
    {
      v: "desafios",
      label: "Desafios",
      icon: data.desafio,
    },
    {
      v: "meritos",
      label: "Méritos",
      icon: data.merito,
    },
    {
      v: "agendar",
      label: "Agendamentos",
      icon: data.ranking,
    },
    {
      v: "feed",
      label: "Feed",
      icon: data.feed,
    },
    {
      v: "cardapio",
      label: "Cardápio",
      icon: data.loja,
    },
    {
      v: "transferir",
      label: "Enviar Tokens",
      icon: data.enviar,
    },
    {
      v: "perfil",
      label: "Perfil",
      icon: data.perfil,
    },
  ].filter((item) => isScreenAllowed(currentStudent, item.v));
  const itensAdmin = [
    {
      aba: "conteudos-adm",
      label: "Reforço",
      icon: data.conteudo,
    },
    {
      aba: "vestibulares-adm",
      label: "Vestibulares",
      icon: data.vestibular,
    },
    {
      aba: "simuladores-conteudo-adm",
      label: "Simuladores",
      icon: data.simulador,
    },
    {
      aba: "olimpiada-conteudo-adm",
      label: "Olimpíadas",
      icon: data.olimpiada,
    },
    {
      aba: "meritos-adm",
      label: "Méritos",
      icon: data.merito,
    },
    {
      aba: "relatorio",
      label: "Relatório",
      icon: data.ranking,
    },
    {
      aba: "grupos-acesso",
      label: "Grupos de Acesso",
      icon: data.merito,
    },
    {
      aba: "casas",
      label: "Instituições",
      icon: data.merito,
    },
    {
      aba: "atividades",
      label: "Pontuação",
      icon: data.ranking,
    },
  ];
  return (
    <aside className={"sidebar ".concat(open ? "open" : "")}>
      <div
        className={"sb-logo"}
        style={{
          cursor: "pointer",
        }}
        onClick={() => nav(adminLogged ? "admin" : "feed")}
      >
        <div className={"sb-logo-title"}>{"Daniel Marlon"}</div>
        <div className={"sb-logo-sub"}>{"Reforço Escolar"}</div>
      </div>
      {currentStudent && (
        <div
          className={"sb-user"}
          style={{
            cursor: "pointer",
          }}
          onClick={() => nav("perfil")}
        >
          <div
            className={"sb-av"}
            style={
              currentStudent.foto
                ? {
                    backgroundImage: "url(".concat(
                      sourceImage(currentStudent.foto),
                      ")",
                    ),
                  }
                : {
                    background: casa?.cor || "#4FB3A9",
                  }
            }
          >
            {!currentStudent.foto && DefaultAvatar()}
          </div>
          <div
            style={{
              flex: 1,
              minWidth: 0,
            }}
          >
            <div
              className={"sb-name"}
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {currentStudent.nome.split(" ")[0]}
            </div>
            <div className={"sb-sub"}>{casa?.nome || ""}</div>
          </div>
        </div>
      )}
      {adminLogged && !currentStudent && (
        <div className={"sb-user"}>
          <div
            className={"sb-av"}
            style={{
              background: "#FF8C42",
            }}
          >
            {DefaultAvatar()}
          </div>
          <div>
            <div className={"sb-name"}>{"Administrador"}</div>
            <div className={"sb-sub"}>{"Painel Admin"}</div>
          </div>
        </div>
      )}
      <nav className={"sb-nav"}>
        {currentStudent && (
          <React.Fragment>
            <div className={"sb-section"}>{"Navegacao"}</div>
            {itensAluno.map((item) => (
              <button
                type={"button"}
                className={"sb-item "
                  .concat(
                    view === item.v && "admin" !== view ? "active" : "",
                    " ",
                  )
                  .concat(item.destaque ? "destaque" : "")}
                aria-label={
                  item.label + (notificationDots[item.v] ? ", novidades" : "")
                }
                onClick={() => nav(item.v)}
                key={item.v}
              >
                <span
                  style={{
                    flex: 1,
                  }}
                >
                  {item.label}
                </span>
                {notificationDots[item.v] && (
                  <span
                    className={"dm-menu-dot"}
                    aria-hidden={true}
                    style={{
                      display: "inline-block",
                      width: 7,
                      height: 7,
                      flex: "0 0 7px",
                      borderRadius: "50%",
                      background: view === item.v ? "#205B4A" : "#70DBB4",
                    }}
                  />
                )}
                {item.badge && <span className={"sb-badge"}>{item.badge}</span>}
              </button>
            ))}
          </React.Fragment>
        )}
        {adminLogged && (
          <React.Fragment>
            <div
              className={"sb-section"}
              style={{
                marginTop: currentStudent ? 8 : 0,
              }}
            >
              {"Administração"}
            </div>
            {itensAdmin.map((item) => (
              <button
                className={"sb-item ".concat(
                  "admin" === view && adminAba === item.aba ? "active" : "",
                )}
                onClick={() => {
                  var aba;
                  aba = item.aba;
                  goto("admin");
                  setAdminAba(aba);
                  onClose();
                  return;
                }}
                key={item.aba}
              >
                <span
                  style={{
                    flex: 1,
                  }}
                >
                  {item.label}
                </span>
                {item.badge && <span className={"sb-badge"}>{item.badge}</span>}
              </button>
            ))}
          </React.Fragment>
        )}
        {!currentStudent && !adminLogged && (
          <React.Fragment>
            <button
              className={"sb-item ".concat("feed" === view ? "active" : "")}
              onClick={() => nav(adminLogged ? "admin" : "feed")}
            >
              <span
                style={{
                  flex: 1,
                }}
              >
                {"Feed"}
              </span>
            </button>
            <button
              className={"sb-item ".concat("rankings" === view ? "active" : "")}
              onClick={() => nav("rankings")}
            >
              <span
                style={{
                  flex: 1,
                }}
              >
                {"Ranking"}
              </span>
            </button>
          </React.Fragment>
        )}
      </nav>
      <div className={"sb-footer"}>
        {currentStudent && isScreenAllowed(currentStudent, "extrato") && (
          <button
            onClick={() => nav("extrato")}
            style={{
              width: "100%",
              background: "rgba(255,255,255,0.07)",
              borderRadius: 9,
              padding: "9px 10px",
              marginBottom: 8,
              border: "1px solid rgba(255,255,255,0.1)",
              cursor: "pointer",
              fontFamily: "inherit",
              textAlign: "left",
              transition: "background .12s",
            }}
            onMouseOver={(value) =>
              (value.currentTarget.style.background = "rgba(255,255,255,0.12)")
            }
            onMouseOut={(value) =>
              (value.currentTarget.style.background = "rgba(255,255,255,0.07)")
            }
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-end",
                marginBottom: 5,
              }}
            >
              <div>
                <div
                  style={{
                    fontSize: 8,
                    color: "rgba(255,255,255,0.35)",
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: ".1em",
                    marginBottom: 2,
                  }}
                >
                  {"Tokens"}
                </div>
                <div
                  style={{
                    fontSize: 16,
                    fontWeight: 800,
                    color: "#4FB3A9",
                    lineHeight: 1,
                  }}
                >
                  {fmtNum(tok)}
                </div>
              </div>
              <div
                style={{
                  textAlign: "right",
                }}
              >
                <div
                  style={{
                    fontSize: 8,
                    color: "rgba(255,255,255,0.35)",
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: ".1em",
                    marginBottom: 2,
                  }}
                >
                  {"Pontos"}
                </div>
                <div
                  style={{
                    fontSize: 16,
                    fontWeight: 800,
                    color: "#FF8C42",
                    lineHeight: 1,
                  }}
                >
                  {fmtNum(pts)}
                </div>
              </div>
            </div>
            <div
              style={{
                fontSize: 9,
                color: "rgba(255,255,255,0.3)",
                display: "flex",
                alignItems: "center",
                gap: 4,
              }}
            >
              <svg
                width={"9"}
                height={"9"}
                viewBox={"0 0 24 24"}
                fill={"none"}
                stroke={"currentColor"}
                strokeWidth={"2.5"}
                strokeLinecap={"round"}
              >
                <polyline points={"22 12 18 12 15 21 9 3 6 12 2 12"} />
              </svg>
              {"Ver extrato completo"}
            </div>
          </button>
        )}
        <button
          className={"sb-sair"}
          onClick={() => {
            logout();
            showFlash("Até logo!", "in");
            onClose();
          }}
        >
          <span
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
            }}
          >
            <span
              style={{
                width: 15,
                height: 15,
                display: "inline-flex",
              }}
            >
              {data.sair}
            </span>
            {"Sair da conta"}
          </span>
        </button>
      </div>
    </aside>
  );
}
